import Vue from "vue";

import AccountRegister from "@Account/Scripts/Components/Account/AccountRegister.vue";

import MyNotification from "@Scripts/Components/MyNotification/MyNotification.vue";
import MyNotificationInfo from "@Scripts/Components/MyNotification/MyNotificationInfo/MyNotificationInfo.vue";

// import NextSurvey from "@Scripts/Components/NextSurvey/NextSurvey.vue";

import GlobalCarItem from "@Scripts/Components/GlobalCarCatalogueList/GlobalCarItem/GlobalCarItem.vue";
import GlobalCarItemImages from "@Scripts/Components/GlobalCarCatalogueList/GlobalCarItem/GlobalCarItemImages.vue";
import ApplicationFavorite from "@Scripts/Components/GlobalCatalogueList/ApplicationFavorite/ApplicationFavorite.vue";
import GlobalCarListFilter from "@Scripts/Components/GlobalCarCatalogueList/GlobalCarListFilter/GlobalCarListFilter.vue";
import ManufacturerReferences from "@Scripts/Components/GlobalCarCatalogueDetail/ManufacturerReferences/ManufacturerReferences.vue";
import GlobalCarApplications from "@Scripts/Components/GlobalCarCatalogueDetail/GlobalCarApplications/GlobalCarApplications.vue";
import GlobalCarRelatedProducts from "@Scripts/Components/GlobalCarCatalogueDetail/GlobalCarRelatedProducts/GlobalCarRelatedProducts.vue";
import ProductFavorite from "@Scripts/Components/GlobalCatalogueDetail/ProductFavorite/ProductFavorite.vue";

import GlobalBikeListFilter from "@Scripts/Components/GlobalBikeCatalogueList/GlobalBikeListFilter/GlobalBikeListFilter.vue";
import GlobalBikeItem from "@Scripts/Components/GlobalBikeCatalogueList/GlobalBikeItem/GlobalBikeItem.vue";
import GlobalBikeItemImages from "@Scripts/Components/GlobalBikeCatalogueList/GlobalBikeItem/GlobalBikeItemImages.vue";
import GlobalBikeApplications from "@Scripts/Components/GlobalBikeCatalogueDetail/GlobalBikeApplications/GlobalBikeApplications.vue";
import GlobalBikeRelatedProducts from "@Scripts/Components/GlobalBikeCatalogueDetail/GlobalBikeRelatedProducts/GlobalBikeRelatedProducts.vue";

import Chat from "@Scripts/Components/Chat/Chat.vue";
import LanguageSelector from "@Scripts/Components/LanguageSelector/LanguageSelector.vue";
import LanguageSelectorCta from "@Scripts/Components/LanguageSelector/LanguageSelectorCta.vue";

import CountryCheck from "@Scripts/Components/CountryCheck/CountryCheck.vue";

import GlobalComparator from "@Scripts/Components/GlobalComparator/GlobalComparator.vue";
import GlobalComparatorCta from "@Scripts/Components/GlobalComparator/GlobalComparatorCta.vue";

import Feedback from "@Scripts/Components/Feedback/Feedback.vue";

import AccountLogout from "@Scripts/Components/MyBremboParts/Profile/AccountLogout.vue";
import AccountEdit from "@Scripts/Components/MyBremboParts/Profile/AccountEdit.vue";
import AccountProfileEdit from "@Scripts/Components/MyBremboParts/Profile/AccountProfileEdit.vue";
import AccountUserInfo from "@Account/Scripts/Components/Account/AccountUserInfo.vue";
import AccountNotificationPreferences from "@Scripts/Components/MyBremboParts/Profile/AccountNotificationPreferences.vue";

import MyAssociationRequest from "@Scripts/Components/MyBremboParts/Expert/MyAssociationRequest.vue";
import MyGeoMarker from "@Scripts/Components/MyBremboParts/Expert/MyGeoMarker.vue";

import MyWidgetProduct from "@Scripts/Components/MyBremboParts/Dashboard/MyWidgetProduct.vue";
import MyWidgetApplication from "@Scripts/Components/MyBremboParts/Dashboard/MyWidgetApplication.vue";
import MyWidgetProfile from "@Scripts/Components/MyBremboParts/Dashboard/MyWidgetProfile.vue";
import MyWidgetSupport from "@Scripts/Components/MyBremboParts/Dashboard/MyWidgetSupport.vue";
import MyWidgetTraining from "@Scripts/Components/MyBremboParts/Dashboard/MyWidgetTraining.vue";
import MyWidgetAreaManager from "@Scripts/Components/MyBremboParts/Dashboard/MyWidgetAreaManager.vue";

import MyApplicationList from "@Scripts/Components/MyBremboParts/Application/MyApplicationList.vue";
import MyProductList from "@Scripts/Components/MyBremboParts/Product/MyProductList.vue";
import AddGenuineProduct from "@Scripts/Components/MyBremboParts/Product/AddGenuineProduct.vue";
import MyTrainingList from "@Scripts/Components/MyBremboParts/Training/MyTrainingList.vue";
import TrainingFeedback from "@Scripts/Components/MyBremboParts/Training/TrainingFeedback.vue";
import TrainingRegistrationLink from "@Scripts/Components/MyBremboParts/Training/TrainingRegistrationLink.vue";
import TrainingUnsubscribeLink from "@Scripts/Components/MyBremboParts/Training/TrainingUnsubscribeLink.vue";
import TrainingRegistrationAdd from "@Scripts/Components/MyBremboParts/Training/TrainingRegistrationAdd.vue";
import ActivationSecretCourses from "@Scripts/Components/MyBremboParts/Training/ActivationSecretCourses.vue";
import TrainingTest from "@Scripts/Components/MyBremboParts/Training/TrainingTest.vue";
import TrainingTestManualCompleted from "@Scripts/Components/MyBremboParts/Training/TrainingTestManualCompleted.vue";
import NewSupportTicket from "@Scripts/Components/MyBremboParts/Support/NewSupportTicket.vue";
import NewSupportTicketAreaManager from "@Scripts/Components/MyBremboParts/Support/NewSupportTicketAreaManager.vue";
import NewSupportTicketMessage from "@Scripts/Components/MyBremboParts/Support/NewSupportTicketMessage.vue";
import SupportTicketFeedback from "@Scripts/Components/MyBremboParts/Support/SupportTicketFeedback.vue";

import SearchHeader from "@Scripts/Components/MyBremboParts/FileSharing/SearchHeader/SearchHeader.vue";
import SideMenu from "@Scripts/Components/MyBremboParts/FileSharing/SideMenu/SideMenu.vue";
import SectionList from "@Scripts/Components/MyBremboParts/FileSharing/Section/SectionList.vue";
import SectionDetail from "@Scripts/Components/MyBremboParts/FileSharing/Section/SectionDetail.vue";
import SectionEdit from "@Scripts/Components/MyBremboParts/FileSharing/Section/SectionEdit.vue";
import SectionProductImages from "@Scripts/Components/MyBremboParts/FileSharing/Section/SectionProductImages.vue";
import DocumentEdit from "@Scripts/Components/MyBremboParts/FileSharing/Document/DocumentEdit.vue";
import UploadDocuments from "@Scripts/Components/MyBremboParts/FileSharing/Document/UploadDocuments.vue";
import Uploader from "@Scripts/Components/MyBremboParts/FileSharing/Document/Uploader.vue";

import ShareTokenList from "@Scripts/Components/MyBremboParts/FileSharing/ShareToken/ShareTokenList.vue";
import ShareTokenBaloon from "@Scripts/Components/MyBremboParts/FileSharing/ShareToken/ShareTokenBaloon.vue";
import ShareTokenBaloonForm from "@Scripts/Components/MyBremboParts/FileSharing/ShareToken/ShareTokenBaloonForm.vue";
import ShareTokenViewer from "@Scripts/Components/MyBremboParts/FileSharing/ShareToken/ShareTokenViewer.vue";

import RemoveFavorite from "@Scripts/Components/RemoveFavorite/RemoveFavorite.vue";

import NewsletterSubscribe from "@Scripts/Components/Newsletter/NewsletterSubscribe.vue";
import NewsletterSubscribeCta from "@Scripts/Components/Newsletter/NewsletterSubscribeCta.vue";
import NewsletterUnsubscribe from "@Scripts/Components/Newsletter/NewsletterUnsubscribe.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import NotificationToast from "@Scripts/Components/NotificationToast/NotificationToast.vue";

import CatalogueSearch from "@Scripts/Components/CatalogueSearch/CatalogueSearch.vue";
import GlobalCatalogueCarSearch from "@Scripts/Components/CatalogueSearch/GlobalCatalogueCarSearch.vue";
import GlobalCatalogueTruckSearch from "@Scripts/Components/CatalogueSearch/GlobalCatalogueTruckSearch.vue";
import GlobalCatalogueBikeSearch from "@Scripts/Components/CatalogueSearch/GlobalCatalogueBikeSearch.vue";

import ToastHub from "@Scripts/Components/Toast/ToastHub.vue";
import BremboStore from "@Scripts/Components/Toast/BremboStore.vue";
import XtraOrdinaryTour from "@Scripts/Components/Toast/XtraOrdinaryTour.vue";

import WhereToBuyDistributors from "@Scripts/Components/WhereToBuy/WhereToBuyDistributors.vue";
import WhereToBuyMap from "@Scripts/Components/WhereToBuy/WhereToBuyMap.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";
import ExpMenuProductTypes from "@Scripts/Directives/ExpMenuProductTypes/ExpMenuProductTypes";
import TextBoxExpandingMenu from "@Scripts/Directives/TextBoxExpandingMenu/TextBoxExpandingMenu";
import TextBoxExpandingMenuLink from "@Scripts/Directives/TextBoxExpandingMenu/TextBoxExpandingMenuLink";

import SupportSearch from "@Scripts/Components/SupportSearch/SupportSearch.vue";
import TechInfoSearch from "@Scripts/Components/TechInfoSearch/TechInfoSearch.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-mynotification", MyNotification);
        Vue.component("app-mynotificationinfo", MyNotificationInfo);

        // Vue.component("app-nextsurvey", NextSurvey);

        Vue.component("application-favorite", ApplicationFavorite);
        Vue.component("product-favorite", ProductFavorite);

        Vue.component("manufacturer-references", ManufacturerReferences);
        Vue.component("app-globalcaritem", GlobalCarItem);
        Vue.component("app-globalcaritemimages", GlobalCarItemImages);
        Vue.component("app-globalcarapplications", GlobalCarApplications);
        Vue.component("app-globalcarrelatedproducts", GlobalCarRelatedProducts);
        Vue.component("app-globalcarlistfilter", GlobalCarListFilter);

        Vue.component("app-globalbikelistfilter", GlobalBikeListFilter);
        Vue.component("app-globalbikeitem", GlobalBikeItem);
        Vue.component("app-globalbikeitemimages", GlobalBikeItemImages);
        Vue.component("app-globalbikeapplications", GlobalBikeApplications);
        Vue.component("app-globalbikerelatedproducts", GlobalBikeRelatedProducts);

        Vue.component("chat", Chat);
        Vue.component("app-languageselector", LanguageSelector);
        Vue.component("app-languageselectorcta", LanguageSelectorCta);

        Vue.component("app-countrycheck", CountryCheck);

        Vue.component("app-globalcomparator", GlobalComparator);
        Vue.component("app-globalcomparatorcta", GlobalComparatorCta);

        Vue.component("app-feedback", Feedback);

        Vue.component("app-accountregister", AccountRegister);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountedit", AccountEdit);
        Vue.component("app-accountprofileedit", AccountProfileEdit);
        Vue.component("app-accountuserinfo", AccountUserInfo);
        Vue.component("app-accountnotificationpreferences", AccountNotificationPreferences);

        Vue.component("app-myassociationrequest", MyAssociationRequest);
        Vue.component("app-mygeomarker", MyGeoMarker);

        Vue.component("app-mywidgetproduct", MyWidgetProduct);
        Vue.component("app-mywidgetapplication", MyWidgetApplication);
        Vue.component("app-mywidgetprofile", MyWidgetProfile);
        Vue.component("app-mywidgetsupport", MyWidgetSupport);
        Vue.component("app-mywidgettraining", MyWidgetTraining);
        Vue.component("app-mywidgetareamanager", MyWidgetAreaManager);

        Vue.component("app-myapplicationlist", MyApplicationList);
        Vue.component("app-myproductlist", MyProductList);
        Vue.component("app-addgenuineproduct", AddGenuineProduct);
        Vue.component("app-mytraininglist", MyTrainingList);
        Vue.component("app-trainingfeedback", TrainingFeedback);
        Vue.component("app-trainingregistrationlink", TrainingRegistrationLink);
        Vue.component("app-trainingunsubscribelink", TrainingUnsubscribeLink);
        Vue.component("app-trainingregistrationadd", TrainingRegistrationAdd);
        Vue.component("app-activationsecretcourses", ActivationSecretCourses);
        Vue.component("app-trainingtest", TrainingTest);
        Vue.component("app-trainingtestmanualcompleted", TrainingTestManualCompleted);
        Vue.component("app-newsupportticket", NewSupportTicket);
        Vue.component("app-newsupportticketareamanager", NewSupportTicketAreaManager);
        Vue.component("app-newsupportticketmessage", NewSupportTicketMessage);
        Vue.component("app-supportticketfeedback", SupportTicketFeedback);

        Vue.component("app-myfssearchheader", SearchHeader);
        Vue.component("app-myfssidemenu", SideMenu);
        Vue.component("app-myfssectionlist", SectionList);
        Vue.component("app-myfssectiondetail", SectionDetail);
        Vue.component("app-myfssectionedit", SectionEdit);
        Vue.component("app-myfssectionproductimages", SectionProductImages);
        Vue.component("app-myfsdocumentedit", DocumentEdit);
        Vue.component("app-myfsuploaddocuments", UploadDocuments);
        Vue.component("app-myfsuploader", Uploader);

        Vue.component("app-myfssharetokenlist", ShareTokenList);
        Vue.component("app-myfssharetokenbaloon", ShareTokenBaloon);
        Vue.component("app-myfssharetokenbaloonform", ShareTokenBaloonForm);
        Vue.component("app-myfssharetokenviewer", ShareTokenViewer);

        Vue.component("app-removefavorite", RemoveFavorite);

        Vue.component("app-newslettersubscribe", NewsletterSubscribe);
        Vue.component("app-newslettersubscribecta", NewsletterSubscribeCta);
        Vue.component("app-newsletterunsubscribe", NewsletterUnsubscribe);

        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-notificationtoast", NotificationToast);

        Vue.component("app-cataloguesearch", CatalogueSearch);
        Vue.component("app-globalcataloguecarsearch", GlobalCatalogueCarSearch);
        Vue.component("app-globalcataloguetrucksearch", GlobalCatalogueTruckSearch);
        Vue.component("app-globalcataloguebikesearch", GlobalCatalogueBikeSearch);

        Vue.component("app-toasthub", ToastHub);
        Vue.component("app-brembostore", BremboStore);
        Vue.component("app-xtraordinarytour", XtraOrdinaryTour);

        Vue.component("app-wheretobuydistributors", WhereToBuyDistributors);
        Vue.component("app-wheretobuymap", WhereToBuyMap);

        Vue.component("app-supportsearch", SupportSearch);
        Vue.component("app-techinfosearch", TechInfoSearch);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
        Vue.directive("exp-menu-product-types", ExpMenuProductTypes);
        Vue.directive("textbox-expanding-menu", TextBoxExpandingMenu);
        Vue.directive("textbox-expanding-menu-link", TextBoxExpandingMenuLink);
    }
}